import JSZip from "jszip";
import ValdiationFormArcGIS from "./ValidationFromArcGIS.js";
export default class DataValidation {
  constructor() {
    this.fileTypes = [/* "glTF", "gltf", */ "glb", "zip"];
    this.csvWEBstructure = ["X", "Y", "Z", "name"];

    this.MAX_FILESIZE_MB = 50;
    this.fileExtension = null;
    this.file = null;
    this.zipFiles = null;
  }

  async validate(file) {
    this.file = file;
    this.fileExtension = file.name.split(/\.(?=[^\.]+$)/);
    const validFormat = this.supportedFormat();

    // Validation - format
    if (validFormat === true) {
      const validSize = this.fileSize();

      // Validation - size
      if (validSize === true) {
        const isZip = this.isZip();

        // It is ZIP file
        if (isZip) {
          const val = await this.unzipFile();
          this.zipFiles = val;
          const isglb = this.isGLBFIle(val);

          if (isglb) {
            const iscsv = this.isCSV(val);

            if (iscsv) {
              const validcsv = await this.csvIsValid(val);

              if (validcsv) {
                return {
                  // ✅ Succes - insert model to scene and layerlist from WEB App
                  kind: "success",
                  message: "inserttolayerlist",
                  from: "WebApp",
                };
              } else {
                return {
                  // ❌ Danger - Invalid CSV
                  kind: "danger",
                  message: "invalidcsv",
                };
              }
            } else {
              const arcgisValid = new ValdiationFormArcGIS(val);
              const resourcs = await arcgisValid.validate();
              return resourcs;
            }
          } else {
            // ❌ Danger - Invalid size
            return {
              kind: "danger",
              message: "zipnotcontainglb",
            };
          }
        } else {
          // ✅ Succes - insert glb file to the web scene
          return {
            kind: "success",
            message: "insertbyhand",
            from: "GLB",
          };
        }
      } else {
        // ❌ Danger - Invalid size
        return {
          kind: "danger",
          message: "filesizetolarge",
        };
      }
    } else {
      // ❌ Danger - Invalid format
      return {
        kind: "danger",
        message: "notsuportedformat",
      };
    }
  }

  supportedFormat() {
    if (!this.fileTypes.includes(this.fileExtension[1])) {
      return false;
    } else {
      return true;
    }
  }

  fileSize() {
    const bytes = this.file.size;
    const mb = bytes / (1024 * 1024);
    if (mb > this.MAX_FILESIZE_MB) {
      return false;
    } else {
      return true;
    }
  }

  isZip() {
    if (this.fileExtension[1] === "zip") {
      return true;
    } else {
      return false;
    }
  }

  async unzipFile() {
    const zip = await JSZip.loadAsync(this.file);
    const objectValues = Object.values(zip.files);

    return objectValues;
  }
  isGLBFIle(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const glbEntry = findByExt(".glb");
    // const glbtEntry = findByExt(".gltf");
    if (!glbEntry) {
      return false;
    } else {
      return true;
    }
  }
  isCSV(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const csvEntery = findByExt(".csv");
    if (csvEntery) {
      return true;
    } else {
      return false;
    }
  }

  async csvIsValid(zipFiles) {
    const findByExt = (ext) =>
      zipFiles.find((f) => !f.dir && f.name.toLowerCase().endsWith(ext));
    const csvEntery = findByExt(".csv");
    const csvText = await csvEntery.async("text");
    const csvRows = csvText
      .trim()
      .split("\n")
      .map((row) => row.split(","));

    const isHaveAllValue = this.arraysEqual(csvRows[0], this.csvWEBstructure);

    if (isHaveAllValue) {
      return true;
    } else {
      return false;
    }
  }

  arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  success() {
    return this.noticeInputs(
      "success",
      "Model byl uspěšně nahrán",
      "Model byl uspěšně nahrán do webové scény."
    );
  }

  noticeInputs(kind, title, message) {
    return {
      kind: kind,
      title: title,
      message: message,
    };
  }
}
